import { Body, Content, EmptyUIIconStyled, RedirectButton, Root, Title } from './EmptyUIStyle';

interface EmptyUIProps {
  title: string;
  description: string;
  buttonLabel: string;
  onClick: () => void;
}

function EmptyUI({ title, description, buttonLabel, onClick }: EmptyUIProps) {
  return (
    <Root>
      <EmptyUIIconStyled />
      <Content>
        <Title>{title}</Title>
        <Body>{description}</Body>
        <RedirectButton onClick={onClick}>{buttonLabel}</RedirectButton>
      </Content>
    </Root>
  );
}

export default EmptyUI;
